import React, { useState, useEffect } from 'react';
import { Input, DatePicker, Radio, Select, Button, Slider, Switch, InputNumber,App } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import styles from './GoLiveNowVideo.module.scss';
import LiveVideo from '@/pages/LiveNow/components/LiveVideo/LiveVideo';
import LiveChat from '@/pages/LiveNow/components/LiveChat/LiveChat';

/**
 * GoLiveNow 组件 - 用于设置和开始直播的界面组件
 * 提供直播标题设置、时间选择、音视频控制、美颜功能等配置选项
 */
const GoLiveNowVideo: React.FC = () => {
  // 使用 Redux dispatch 和 Antd message hook
  const dispatch = useAppDispatch();
  const { message } = App.useApp();
  
  //mounted 和unmounted
  useEffect(() => {
   
  }, []);

  return (
    <div className={styles['go-live-container']}>
      <div className="text-[32px] text-[#2AAD61] font-bold leading-[45px] mb-[40px]">
        Townloop Live
      </div>
      <div className={styles['live-top-box']}>
        <div className={styles['live-top-left']}>
          <LiveVideo isStreamer={true} />
        </div>
        <div className={styles['live-top-right']}>
          <LiveChat />
        </div>
      </div>
    </div>
  );
};

export default GoLiveNowVideo; 

